import { Tag, type TagVariant } from '@components';
import type { FC } from 'react';

type Props = {
  matchStrength: string;
  label?: (matchScore: number) => string;
};

export const MatchChip: FC<Props> = ({ matchStrength, label }) => {
  const parsedFloat = parseFloat(matchStrength);
  if (Number.isNaN(parsedFloat)) {
    return <Tag variant='Gray' label='No Match' />;
  }

  const matchScore = Math.round(parsedFloat / 10);
  let variant: TagVariant = 'Success';
  if (matchScore < 7) {
    variant = 'Red';
  } else if (matchScore <= 8) {
    variant = 'Yellow';
  }

  return <Tag variant={variant} label={label ? label(matchScore) : `${matchScore}/10`} />;
};
